export default __webpack_public_path__ + "static/media/icon_frontier.605eae13.png";